import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import {
  AuthService,
  TipoPortal,
} from '../../services/authService/auth.service';

@Component({
  selector: 'app-espaco-do-professor',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, MatIcon],
  templateUrl: './espaco-do-professor.component.html',
  styleUrls: ['./espaco-do-professor.component.scss'],
})
export class EspacoDoProfessorComponent {
  loginForm: FormGroup;
  mostrarSenha = false;
  erroLogin = false;
  tipoPortal: TipoPortal = 'professor';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private auth: AuthService
  ) {
    this.loginForm = this.fb.group({
      usuario: ['', Validators.required],
      senha:   ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  mudarVisibilidadeSenha(): void {
    this.mostrarSenha = !this.mostrarSenha;
  }

  login(): void {
    if (this.loginForm.invalid) return;

    const { usuario, senha } = this.loginForm.value;
    const valido = this.auth.login(this.tipoPortal, usuario, senha);

    if (valido) {
      this.erroLogin = false;
      localStorage.setItem('usuarioLogado', JSON.stringify(usuario));
      this.router.navigate(['/espaco-professor', 'dashboard']);
    } else {
      this.erroLogin = true;
    }
  }

  abrirEsqueciSenha(): void {
    console.log('Esqueceu senha');
  }

  guiaRapidoAcesso(): void {
    console.log('Guia rapido acesso');
  }
}
